import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import ConnectionsHeader from '../components/connections/ConnectionsHeader';
import ConnectionsList from '../components/connections/ConnectionsList';
import ConnectionsFilters from '../components/connections/ConnectionsFilters';
import { XIcon } from 'lucide-react';
const ConnectionsPage = () => {
  const [activeFilter, setActiveFilter] = useState<'all' | 'courses' | 'connected'>('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-1632">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-1633">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1634"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-1635">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1636">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-1637">
              <span className="sr-only" data-id="element-1638">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-1639" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-1640">
            <Sidebar activePage="community" data-id="element-1641" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-1642">
        <Sidebar activePage="community" data-id="element-1643" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1644">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-1645" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-1646">
          <div className="pt-4 md:pt-6 max-w-6xl mx-auto" data-id="element-1647">
            <ConnectionsHeader data-id="element-1648" />
            <div className="mt-6" data-id="element-1649">
              <ConnectionsFilters activeFilter={activeFilter} setActiveFilter={setActiveFilter} searchQuery={searchQuery} setSearchQuery={setSearchQuery} data-id="element-1650" />
            </div>
            <div className="mt-6" data-id="element-1651">
              <ConnectionsList activeFilter={activeFilter} searchQuery={searchQuery} data-id="element-1652" />
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default ConnectionsPage;